module.exports = __webpack_public_path__ + "static/media/pg05.765a484a.jpg";